<div class="dialog-content-wrapper">
    <mat-toolbar class="mat-primary m-0">
        <mat-toolbar-row
            fxFlex
            fxLayout="row"
            fxLayoutAlign="space-between center"
        >
            <span class="title dialog-title text-truncate"
                >Gestión de Invitaciones a cotizar</span
            >
            <button
                style="float: right"
                mat-icon-button
                (click)="dialogRef.close()"
                aria-label="Close dialog"
            >
                <mat-icon>close</mat-icon>
            </button>
        </mat-toolbar-row>
    </mat-toolbar>

    <mat-dialog-content class="p-16 pb-0 m-0">
        <div
            fxFlex
            fxFlexAlign="start start"
            fxLayout="row"
            fxLayout.lt-md="column"
            fxLayoutGap="15px"
        >
            <div fxFlex="30" fxFlex.lt-md="100">
                <app-listado-contratistas
                    [idComuna]="data.idComuna"
                    [idRegion]="data.idRegion"
                    [idServicioSolicitudCotizacion]="
                        data.idServicioSolicitudCotizacion
                    "
                ></app-listado-contratistas>
            </div>
            <div fxFlex="70" fxFlex.lt-md="100">
                <app-listado-invitaciones-contratistas
                    [idServicioSolicitudCotizacion]="
                        data.idServicioSolicitudCotizacion
                    "
                ></app-listado-invitaciones-contratistas>
            </div>
        </div>
    </mat-dialog-content>
    <mat-divider></mat-divider>
    <mat-dialog-actions
        class="m-0 p-16"
        fxLayout="row"
        fxLayoutAlign="end center"
    >
        <button mat-raised-button color="accent" mat-dialog-close>
            Cerrar
        </button>
    </mat-dialog-actions>
</div>
